import { EventDetailLayout } from '@layouts/membership/event/EventDetailLayout'
import AnalyticsTab from '@pages/membership/events/AnalyticsTab'
import BookingTab from '@pages/membership/events/BookingTab'
import InformationsTab from '@pages/membership/events/InformationsTab'
import ParticipantsTab from '@pages/membership/events/ParticipantsTab'
import SettingsTab from '@pages/membership/events/SettingsTab'
import { Navigate, RouteObject } from 'react-router-dom'

const eventDetailRoutes: RouteObject[] = [
  {
    element: <EventDetailLayout />,
    children: [
      { path: 'informations', element: <InformationsTab /> },
      { path: 'participants', element: <ParticipantsTab /> },
      { path: 'booking', element: <BookingTab /> },
      { path: 'analytics', element: <AnalyticsTab /> },
      { path: 'settings', element: <SettingsTab /> },

      { index: true, element: <Navigate to="informations" replace /> },
      { path: '*', element: <Navigate to="informations" replace /> },
    ],
  },
]

export default eventDetailRoutes
